import React from 'react';
import {motion} from 'framer-motion';

const Experience=()=> {
  const experiences=[
    {
      year: '2018 - Present',
      title: 'Founder & Host',
      company: 'That Bracket Show',
      description: 'Created and host a leading college basketball analytics and entertainment platform, developing strategic sales and business development initiatives for sports media partnerships.',
      achievements: [
        'Built engaged audience of college basketball fans and industry professionals',
        'Developed comprehensive sales strategies for sports media partnerships',
        'Established platform as trusted source for college basketball content and analysis',
        'Created strategic business relationships with sports media organizations and sponsors'
      ]
    },
    {
      year: '2015 - Present',
      title: 'Sports Industry Consultant',
      company: 'Klein Sports Consulting',
      description: 'Providing strategic sales, business development, and revenue growth consulting services to sports teams, events, and media companies.',
      achievements: [
        'Increased client market share by 40% through strategic sales and business development initiatives',
        'Developed new revenue streams resulting in 25% growth for sports organizations',
        'Expanded client pipeline through targeted sales strategies and partnership development',
        'Implemented data-driven sales approaches to optimize client acquisition and retention'
      ]
    },
    {
      year: '2010 - 2018',
      title: 'Business Development Executive',
      company: 'Sports Media & Entertainment',
      description: 'Led sales and business development initiatives for sports media companies, focusing on revenue growth, client acquisition, and strategic partnerships with sports teams and events.',
      achievements: [
        'Managed multi-million dollar sales portfolios and strategic accounts',
        'Developed and executed sales strategies resulting in 60% client growth',
        'Established key partnerships with major sports teams, events, and media organizations',
        'Created innovative sales processes and revenue streams through strategic business development'
      ]
    },
    {
      year: '2005 - 2010',
      title: 'Sales Manager',
      company: 'Regional Sports Networks',
      description: 'Managed sales operations and client relationships for regional sports broadcasting networks, focusing on advertising sales and corporate partnerships with sports teams and events.',
      achievements: [
        'Increased advertising sales by 35% through targeted sales campaigns',
        'Developed comprehensive client retention and acquisition programs',
        'Managed relationships with key advertisers, sports teams, and corporate sponsors',
        'Implemented market research initiatives to guide sales and programming decisions'
      ]
    },
    {
      year: '1999 - 2005',
      title: 'Sports Marketing & Sales Coordinator',
      company: 'Collegiate Athletic Programs',
      description: 'Coordinated sales and marketing activities for collegiate athletic programs while developing foundational expertise in sports business operations and team partnerships.',
      achievements: [
        'Managed sales campaigns for multiple collegiate sports programs and events',
        'Increased ticket sales and corporate partnerships through innovative sales strategies',
        'Developed relationships with local businesses, media, and community organizations',
        'Created comprehensive sales materials and promotional content for sports teams and events'
      ]
    }
  ];

  return (
    <section id="experience" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Professional <span className="text-orange-600"> Experience</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Over 25 years of proven results in sports industry sales, business development, and revenue growth across sports teams, events, and media organizations.
          </p>
        </motion.div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-orange-200 transform md:-translate-x-0.5"></div>

          <div className="space-y-12">
            {experiences.map((experience,index)=> (
              <motion.div
                key={experience.title}
                initial={{opacity: 0,y: 50}}
                whileInView={{opacity: 1,y: 0}}
                viewport={{once: true}}
                transition={{duration: 0.6,delay: index * 0.2}}
                className={`relative flex items-center ${index % 2===0 ? 'md:flex-row' : 'md:flex-row-reverse'} flex-col md:flex-row`}
              >
                {/* Timeline dot */}
                <div className="absolute left-8 md:left-1/2 w-4 h-4 bg-orange-600 rounded-full transform md:-translate-x-2 z-10 border-4 border-white shadow-lg"></div>

                {/* Content card */}
                <div className={`w-full md:w-5/12 ml-16 md:ml-0 ${index % 2===0 ? 'md:mr-8' : 'md:ml-8'}`}>
                  <motion.div
                    whileHover={{scale: 1.02}}
                    className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-300"
                  >
                    <div className="text-orange-600 font-semibold text-sm mb-2">{experience.year}</div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{experience.title}</h3>
                    <div className="text-lg text-orange-600 font-semibold mb-4">{experience.company}</div>
                    <p className="text-gray-600 leading-relaxed mb-6">{experience.description}</p>
                    
                    <div className="space-y-2">
                      <h4 className="font-semibold text-gray-900 text-sm">Key Achievements:</h4>
                      {experience.achievements.map((achievement,achievementIndex)=> (
                        <motion.div
                          key={achievementIndex}
                          initial={{opacity: 0,x: -20}}
                          whileInView={{opacity: 1,x: 0}}
                          viewport={{once: true}}
                          transition={{duration: 0.4,delay: (index * 0.2) + (achievementIndex * 0.1)}}
                          className="flex items-start text-gray-600 text-sm"
                        >
                          <div className="w-1.5 h-1.5 bg-orange-600 rounded-full mr-3 mt-2 flex-shrink-0"></div>
                          {achievement}
                        </motion.div>
                      ))}
                    </div>
                  </motion.div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;